import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, CardContent } from '@design-system-coopeuch/web';
import { encuestaActions } from '../../../../application/actions/encuesta';
import btnCerrar from '../../../assets/img/icon/btn-cerrar.svg';
import { WrapperModalEncuestaAbandono } from './styles';
import Pregunta1 from '../../molecules/PreguntasEncuestaAbandono/Pregunta1';
import { Encuesta } from '../../../../utils/Encuesta';
import { codigoAplicacion } from '../../../../utils/index';

const ModalEncuestaAbandono = ({
  setTipoRespuesta,
  setOpenModalEncuestaAbandono,
  setOpenModalRespuestaEncuesta,
  setEncuestaRespondida,
}) => {
  const [botonDisabled, setBotonDisabled] = useState(true);
  const [calificacionRadioButton, setCalificacionRadioButton] = useState(0);
  const [respuestaTextoPregunta1, setRespuestaTextoPregunta1] = useState('');

  const storeDataEncuesta = useSelector((store) => store.entities.encuesta.response);

  const dispatch = useDispatch();

  const enviar = () => {
    setBotonDisabled(true);
    dispatch(
      encuestaActions.encuesta({
        codigoAplicacion,
        codigoEncuesta: Encuesta.abandono.codigo,
        preguntas: [
          {
            idPregunta: Encuesta.abandono.preguntas[0].idPregunta,
            respuestas: [
              {
                idOpcion: calificacionRadioButton,
                comentario: respuestaTextoPregunta1,
              },
            ],
          },
        ],
      })
    );
    setEncuestaRespondida(true);
  };

  useEffect(() => {
    if ('code' in storeDataEncuesta) {
      setBotonDisabled(false);
      setOpenModalEncuestaAbandono(false);
      setOpenModalRespuestaEncuesta(true);
    }
    const { code } = storeDataEncuesta;
    if (code === 0) {
      setTipoRespuesta('exito');
    } else {
      setTipoRespuesta('error');
    }
  }, [storeDataEncuesta])

  return (
    <WrapperModalEncuestaAbandono>
      <div className="modal">
        <div className="modal-content">
          <Card>
            <CardContent className="tituloModal">
              <div className="barraTop">
                <Button variant="text" onClick={() => setOpenModalEncuestaAbandono(false)}>
                  <img src={btnCerrar} alt="close" />
                </Button>
              </div>
              <Pregunta1
                setBotonDisabled={setBotonDisabled}
                calificacionRadioButton={calificacionRadioButton}
                setCalificacionRadioButton={setCalificacionRadioButton}
                respuestaTexto={respuestaTextoPregunta1}
                setRespuestaTexto={setRespuestaTextoPregunta1}
              />
            </CardContent>
            <CardContent className="cardSiguiente">
              <div className="footerModalAbandono">
                <Button
                  className="retomarEncuestaBoton"
                  variant="text"
                  onClick={() => setOpenModalEncuestaAbandono(false)}
                >
                  Retomar solicitud
                </Button>
                <Button
                  className="botonTerminar"
                  variant="outline"
                  onClick={() => enviar()}
                  disabled={botonDisabled}
                >
                  Enviar y terminar
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </WrapperModalEncuestaAbandono>
  );
};
ModalEncuestaAbandono.propTypes = {
  setTipoRespuesta: PropTypes.func.isRequired,
  setOpenModalEncuestaAbandono: PropTypes.func.isRequired,
  setOpenModalRespuestaEncuesta: PropTypes.func.isRequired,
  setEncuestaRespondida: PropTypes.func.isRequired,
};

export default ModalEncuestaAbandono;
